import { jsx as _jsx } from "react/jsx-runtime";
import extensivSpinnerGif from '../../assets/img/extensiv_spinner.gif';
const Spinner = ({ spinnerSize = 70, height = 'calc(100% + 40px)', width = 'calc(100% + 40px)', marginTop = '-20px', marginLeft = '-20px', className, withBackdrop = false }) => {
    return (_jsx("div", Object.assign({ style: {
            height,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: withBackdrop ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0,0,0,0)',
            width,
            marginLeft,
            marginTop,
            zIndex: 10000,
            position: 'relative',
            left: 0,
            top: 0
        }, className: className }, { children: _jsx("img", { src: extensivSpinnerGif, width: spinnerSize, height: spinnerSize }) })));
};
export default Spinner;
//# sourceMappingURL=index.js.map